import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext } from "react";
import useLeadInfo from "../lead-info.hook";

const useMarkAsRubbish = () => {
  const { lead } = useContext(LeadPageContext);

  const {
    handleConfirmUpdate,
    isError,
    isSuccess,
    isLeadLoading,
    isJourneyLoading,
  } = useLeadInfo();

  const handleMarkAsRubbishLead = (reason?: string, comment?: string) => {
    const isCurrentlyRubbish = lead?.data?.lead?.rubbish === true;

    handleConfirmUpdate({
      lead: {
        rubbish: !isCurrentlyRubbish,
        rubbishReason: isCurrentlyRubbish ? null : reason,
        rubbishComment: isCurrentlyRubbish ? null : comment,
      },
    });
  };

  const handleMarkAsRubbishJourney = (reason?: string, comment?: string) => {
    const isCurrentlyRubbish = lead?.data?.rubbish === true;

    handleConfirmUpdate({
      journey: {
        rubbish: !isCurrentlyRubbish,
        rubbishReason: isCurrentlyRubbish ? null : reason,
        rubbishComment: isCurrentlyRubbish ? null : comment,
      },
    });
  };

  return {
    handleMarkAsRubbishLead,
    handleMarkAsRubbishJourney,
    isLeadLoading,
    isJourneyLoading,
    isError,
    isSuccess,
  };
};

export default useMarkAsRubbish;
